import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { getCrew } from "../services/api/getAll";
import { useTranslation } from "react-i18next";
import KlarnaCarousel from "./KlarnaCarousel";

const CrewList = () => {
  const [crewMembers, setCrewMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const { t } = useTranslation();

  useEffect(() => {
    const fetchCrew = async () => {
      try {
        const response = await getCrew();
        const preferredLanguage = localStorage.getItem("language") || "en";

        const parsedCrew = response.items?.map(
          (member: { translations: any[]; photoUrl: any }) => {
            const enTranslation = member.translations.find(
              (t) => t.languageCode === preferredLanguage
            );

            return {
              img: member.photoUrl,
              name: enTranslation?.fullName || "",
              role: enTranslation?.role || "",
              bio: enTranslation?.bio || "",
            };
          }
        );

        setCrewMembers(parsedCrew || []);
      } catch (err: any) {
        setError(err.message || "Failed to load crew data.");
      } finally {
        setLoading(false);
      }
    };

    fetchCrew();
  }, []);

  return (
    <Box
      id="crew"
      sx={{
        position: "relative",
        py: 16,
        px: 3,
        background: "transparent",
        overflow: "hidden",
      }}
    >
      <Box sx={{ position: "relative", zIndex: 2, maxWidth: "1200px", mx: "auto" }}>
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="h3"
            fontWeight={900}
            textAlign="center"
            mb={8}
            sx={{
              fontFamily: "Poppins, Ozen",
              background: "linear-gradient(135deg, #FFAE00 0%, #FF9100 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              textTransform: "uppercase",
              textShadow: "0 0 30px rgba(255, 174, 0, 0.1)",
            }}
          >
            {t("meetTheCrew")}
          </Typography>
        </motion.div>

        <Box sx={{ width: "100%", mt: 2 }}>
          {loading && (
            <Typography sx={{ color: "#ccc", fontFamily: "Poppins", textAlign: "center" }}>
              Loading...
            </Typography>
          )}
          {error && (
            <Typography sx={{ color: "red", fontFamily: "Poppins", textAlign: "center" }}>
              {error}
            </Typography>
          )}
          {!loading && !error && (
            <KlarnaCarousel
              items={crewMembers.map((member: any) => ({
                image: member.img,
                buttonImage: member.img,
                label: member.name,
                role: member.role,
                bio: member.bio,
              }))}
              imageWidth={240}
              imageHeight={240}
              cardRadius={120}
              buttonSize={70}
              curve={4}
              gap={55}
              backgroundColor="rgba(255, 255, 255, 0)"
              labelX={-13}
              labelY={-6}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default CrewList;


